export default __webpack_public_path__ + "static/media/NoDecksPlaceholder.dc3bcc9f.svg";